import { Modal } from "antd";
import { t } from "i18next";
import React from "react";
import { ProfileKosong } from "../../asset";
import getDateTime from "../../util/getDateTime";

const ModalViewDetailAddListOrder = ({
  isModalOpen,
  close,
  data,
  onPreviewImg,
}) => {
  return (
    <Modal
      title=""
      open={isModalOpen}
      onCancel={close}
      footer={null}
      width={1300}
    >
      <div className="overflow-auto max-h-[1000px]">
        <div className="flex flex-col mt-5">
          {/* Cols 1 Order Detail */}
          <div className="flex flex-col mb-6">
            <h3 className="font-roboto text-[20px] font-bold mb-3">
              {t("Order Detail")}
            </h3>
            <div className="flex flex-row justify-between">
              {/* Row 1 */}
              <div className=" w-[26.1rem] flex flex-col">
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Company Profile ID")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">-</p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Customer Profile ID")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.customer_id ? data?.customer_id : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Delivery Type")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.delivery_type ? data?.delivery_type : "-"}{" "}
                  </p>
                </div>
              </div>

              {/* Row 2 */}
              <div className=" w-[26.1rem] flex flex-col">
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("First Name")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.customer_first_name
                      ? data?.customer_first_name
                      : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Last Name")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.customer_last_name
                      ? data?.customer_last_name
                      : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]"> {t("Email")} </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.customer_email ? data?.customer_email : "-"}{" "}
                  </p>
                </div>
              </div>

              {/* Row 3 */}
              <div className=" w-[26.1rem] flex flex-col">
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]"> {t("Phone")} </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.customer_phone ? data?.customer_phone : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]"> {t("Fax")} </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.customer_fax ? data?.customer_fax : "-"}{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Cols 2 Address Detail */}
          <div className="flex flex-col mb-6">
            <h3 className="font-roboto text-[20px] font-bold mb-3">
              {t("Address Detail")}
            </h3>
            <div className="flex flex-row justify-between">
              {/* Row 1 */}
              <div className=" w-[26.1rem] flex flex-col">
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Recipient's Name")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.recipient_name ? data?.recipient_name : "-"}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Recipient's Phone")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.recipient_phone ? data?.recipient_phone : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Country")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.country_name ? data?.country_name : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]"> {t("Island")} </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.island_name ? data?.island_name : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Province")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.province_name ? data?.province_name : "-"}{" "}
                  </p>
                </div>
              </div>

              {/* Row 2 */}
              <div className=" w-[26.1rem] flex flex-col">
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("District")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.district_name ? data?.district_name : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Sub District")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.sub_district_name
                      ? data?.sub_district_name
                      : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Urban Village")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.urban_village_name
                      ? data?.urban_village_name
                      : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Address")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.address ? data?.address : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Neighbourhood")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.neighbourhood ? data?.neighbourhood : "-"}{" "}
                  </p>
                </div>
              </div>

              {/* Row 3 */}
              <div className=" w-[26.1rem] flex flex-col">
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]"> {t("Hamlet")} </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.hamlet ? data?.hamlet : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Postal Code")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.postal_code ? data?.postal_code : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Latittude")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.latitude ? data?.latitude : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Longitude")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.longitude ? data?.longitude : "-"}{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Cols 3 Routes Detail */}
          <div className="flex flex-col mb-6">
            <h3 className="font-roboto text-[20px] font-bold mb-3">
              {t("Routes Detail")}
            </h3>
            <div className="flex flex-row justify-between">
              {/* Row 1 */}
              <div className=" w-[26.1rem] flex flex-col">
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Receipt Name")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.receive_information?.receipt_name
                      ? data?.receive_information?.receipt_name
                      : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Previous Trip")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.receive_information?.previous_trip
                      ? data?.receive_information?.previous_trip
                      : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Trip Route Sequence")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.receive_information?.trip_route_sequence
                      ? data?.receive_information?.trip_route_sequence
                      : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Trip Route Cost")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.receive_information?.trip_route_cost
                      ? "Rp " + data?.receive_information?.trip_route_cost
                      : "Rp 0"}{" "}
                  </p>
                </div>
                <div className="flex flex-row w-full gap-4">
                  <div className="flex flex-col">
                    <p className=" font-roboto text-[14px] text-[#424242] mb-2">
                      {" "}
                      {t("Receipt Image")}{" "}
                    </p>
                    <div className="grid grid-cols-3 gap-2">
                      <div
                        className="w-[100px] h-[100px] border border-b-gray-400 rounded-[5px] flex justify-center items-center p-4 cursor-pointer"
                        onClick={() => {
                          onPreviewImg(
                            data?.receive_information?.receive_image_1
                          );
                        }}
                      >
                        <img
                          className="w-[84px] h-[84px]"
                          src={
                            data?.receive_information?.receive_image_1 === "" ||
                            data?.receive_information?.receive_image_1 === "-"
                              ? ProfileKosong
                              : data?.receive_information?.receive_image_1
                          }
                          alt="profile-icon"
                        />
                      </div>
                      {data?.receive_information?.receive_image_2 === "" ||
                      data?.receive_information?.receive_image_2 ===
                        "-" ? null : (
                        <div
                          className="w-[100px] h-[100px] border border-b-gray-400 rounded-[5px] flex justify-center items-center p-4 cursor-pointer"
                          onClick={() => {
                            onPreviewImg(
                              data?.receive_information?.receive_image_2
                            );
                          }}
                        >
                          <img
                            className="w-[84px] h-[84px]"
                            src={
                              data?.receive_information?.receive_image_2 ===
                                "" ||
                              data?.receive_information?.receive_image_2 === "-"
                                ? ProfileKosong
                                : data?.receive_information?.receive_image_2
                            }
                            alt="profile-icon-2"
                          />
                        </div>
                      )}

                      {data?.receive_information?.receive_image_3 === "" ||
                      data?.receive_information?.receive_image_3 ===
                        "-" ? null : (
                        <div
                          className="w-[100px] h-[100px] border border-b-gray-400 rounded-[5px] flex justify-center items-center p-4 cursor-pointer"
                          onClick={() => {
                            onPreviewImg(
                              data?.receive_information?.receive_image_3
                            );
                          }}
                        >
                          <img
                            className="w-[84px] h-[84px]"
                            src={
                              data?.receive_information?.receive_image_3 ===
                                "" ||
                              data?.receive_information?.receive_image_3 === "-"
                                ? ProfileKosong
                                : data?.receive_information?.receive_image_3
                            }
                            alt="profile-icon-2"
                          />
                        </div>
                      )}

                      {data?.receive_information?.receive_image_4 === "" ||
                      data?.receive_information?.receive_image_4 ===
                        "-" ? null : (
                        <div
                          className="w-[100px] h-[100px] border border-b-gray-400 rounded-[5px] flex justify-center items-center p-4 cursor-pointer"
                          onClick={() => {
                            onPreviewImg(
                              data?.receive_information?.receive_image_4
                            );
                          }}
                        >
                          <img
                            className="w-[84px] h-[84px]"
                            src={
                              data?.receive_information?.receive_image_4 ===
                                "" ||
                              data?.receive_information?.receive_image_4 === "-"
                                ? ProfileKosong
                                : data?.receive_information?.receive_image_4
                            }
                            alt="profile-icon-2"
                          />
                        </div>
                      )}

                      {data?.receive_information?.receive_image_5 === "" ||
                      data?.receive_information?.receive_image_5 ===
                        "-" ? null : (
                        <div
                          className="w-[100px] h-[100px] border border-b-gray-400 rounded-[5px] flex justify-center items-center p-4 cursor-pointer"
                          onClick={() => {
                            onPreviewImg(
                              data?.receive_information?.receive_image_5
                            );
                          }}
                        >
                          <img
                            className="w-[84px] h-[84px]"
                            src={
                              data?.receive_information?.receive_image_5 ===
                                "" ||
                              data?.receive_information?.receive_image_5 === "-"
                                ? ProfileKosong
                                : data?.receive_information?.receive_image_5
                            }
                            alt="profile-icon-2"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Row 2 */}
              <div className=" w-[26.1rem] flex flex-col">
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Routes Distance")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.receive_information?.route_distance
                      ? data?.receive_information?.route_distance
                      : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Routes Estimates Time")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {" "}
                    {data?.route_estimation_time
                      ? data?.route_estimation_time
                      : "-"}{" "}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Routes Status")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]"> - </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Trip Routes Start Time")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {data?.receive_information?.trip_route_start_time
                      ? getDateTime(
                          data?.receive_information?.trip_route_start_time
                        )
                      : "-"}
                  </p>
                </div>
                <p className=" font-roboto text-[14px] text-[#424242] mb-2">
                  {" "}
                  {t("Photo of Payment")}{" "}
                </p>
                <div
                  className="w-[100px] h-[100px] border border-b-gray-400 rounded-[5px] flex justify-center items-center p-4 cursor-pointer"
                  onClick={() => {
                    onPreviewImg(data?.receive_information?.photo_payment);
                  }}
                >
                  <img
                    className="w-[84px] h-[84px]"
                    src={
                      data?.receive_information?.photo_payment === "" ||
                      data?.receive_information?.photo_payment === "-"
                        ? ProfileKosong
                        : data?.receive_information?.photo_payment
                    }
                    alt="payment-img-icon"
                  />
                </div>
              </div>

              {/* Row 3 */}
              <div className=" w-[26.1rem] flex flex-col">
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Trip Routes End Time")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {data?.receive_information?.trip_routes_end_time
                      ? getDateTime(
                          data?.receive_information?.trip_routes_end_time
                        )
                      : "-"}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Trip Routes Pick Up Time")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {data?.receive_information?.trip_routes_pick_up_time
                      ? getDateTime(
                          data?.receive_information?.trip_routes_pick_up_time
                        )
                      : "-"}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Trip Routes Check InTime")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {data?.receive_information?.trip_routes_check_in_time
                      ? getDateTime(
                          data?.receive_information?.trip_routes_check_in_time
                        )
                      : "-"}
                  </p>
                </div>
                <div className="font-roboto mb-2">
                  <p className=" text-[14px] text-[#818181]">
                    {" "}
                    {t("Waiting Time")}{" "}
                  </p>
                  <p className=" text-[20px] text-[#424242]">
                    {data?.receive_information?.waiting_time
                      ? getDateTime(data?.receive_information?.waiting_time)
                      : "-"}
                  </p>
                </div>
                <p className=" font-roboto text-[14px] text-[#424242] mb-2">
                  {" "}
                  {t("Signature Image")}{" "}
                </p>
                <div
                  className="w-[100px] h-[100px] border border-b-gray-400 rounded-[5px] flex justify-center items-center p-4 cursor-pointer"
                  onClick={() => {
                    onPreviewImg(data?.receive_information?.signature_image);
                  }}
                >
                  <img
                    className="w-[84px] h-[84px]"
                    src={
                      data?.receive_information?.signature_image === "" ||
                      data?.receive_information?.signature_image === "-"
                        ? ProfileKosong
                        : data?.receive_information?.signature_image
                    }
                    alt="signature-icon"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Cols 4 Order Notes */}
          <div className="flex flex-col mb-6">
            <h3 className="font-roboto text-[20px] font-bold mb-3">
              {t("Order Notes")}
            </h3>
            <div className="font-roboto mb-2">
              <p className=" text-[14px] text-[#818181]">
                {" "}
                {t("Delivery Noted")}{" "}
              </p>
              <p className=" text-[20px] text-[#424242]">
                {" "}
                {data?.delivery_notes ? data?.delivery_notes : "-"}{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalViewDetailAddListOrder;
